import { BaseSerializer } from "./baseSerializer.ts";
import { ChoiceEnum } from "@models/choiceEnum.ts";

export class ChoiceEnumSerializer extends BaseSerializer {
  public deserialize(data: any): any {
    const gp = new ChoiceEnum();
    this._copyAttributes(gp, data);
    return gp;
  }
}
